// Contrail V3.7.0 — mobile More tab (fleet register and company switch arrive in V3.8.0).
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "../lib/supabase";
import { presenceSignOut } from "../lib/presence";
import { setLayoutOverride } from "../lib/pwa";
import { pickTip } from "../lib/tips";
import { APP_VERSION, PLATFORM } from "../lib/version";
import InstallPrompt from "./InstallPrompt";
import { ChangePassword } from "../ui/UserMenu";

export default function MoreTab({ session }: { session: Session }) {
  const nav = useNavigate();
  const [orgs, setOrgs] = useState<string[]>([]);
  const [tip] = useState(pickTip);
  const [pw, setPw] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { supabase.from("organisations").select("name").order("name").then(({ data }) => setOrgs((data ?? []).map((o) => o.name))); }, []);
  return (
    <div className="m-panel">
      <div className="m-panel-head"><h1>More</h1></div>
      <div className="m-more">
        <section className="m-card">
          <img src="/tf-logo.png" alt="Tracking Fiji" className="m-logo" />
          <div className="sub">{session.user.email}</div>
          {orgs.length > 0 && <div className="m-org">{orgs.length === 1 ? orgs[0] : `${orgs.length} companies`}</div>}
        </section>
        <section className="m-card">
          <h2>Install the app</h2>
          <InstallPrompt />
        </section>
        <section className="m-card m-links">
          <button type="button" onClick={() => { setDone(false); setPw(true); }}>Change password</button>
          {done && <p className="sub" role="status">Password changed.</p>}
          <button type="button" onClick={() => { setLayoutOverride("desktop"); nav("/map"); }}>Open desktop version</button>
          <button type="button" className="danger" onClick={() => presenceSignOut().finally(() => supabase.auth.signOut())}>Sign out</button>
        </section>
        {pw && <ChangePassword email={session.user.email ?? ""} onClose={() => setPw(false)} onDone={() => { setPw(false); setDone(true); }} />}
        <p className="m-tip"><b>Tip:</b> {tip.text}</p>
        <p className="m-ver mono">{PLATFORM} {APP_VERSION} · Tracking Fiji is operated by Skyward Industries Pte Ltd</p>
      </div>
    </div>
  );
}
